import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import TreeView from "src/shared/TreeView/TreeView";
import { TAGS_VIEWER_HEIGHT } from "../consts";
import TagTreeHeader from "./TagTreeHeader";

const TreeViewContainer = styled.div`
  width: 100%;
  min-width: 0;
  height: ${TAGS_VIEWER_HEIGHT};
  overflow: auto;
`;

const TagsTreeView = ({
  treeData,
  onNodeToggled,
  onNodeSelected,
  loadingNodeIds,
}) => {
  const customizeTreeHeader = () => {
    return TagTreeHeader;
  };

  return (
    <TreeViewContainer>
      <TreeView
        data={treeData}
        onNodeToggled={onNodeToggled}
        onNodeSelected={onNodeSelected}
        customizeTreeHeader={customizeTreeHeader}
        loadingNodeIds={loadingNodeIds}
        data-testid="tags-hierarchy-tree"
      />
    </TreeViewContainer>
  );
};

TagsTreeView.propTypes = {
  treeData: PropTypes.array.isRequired,
  onNodeToggled: PropTypes.func,
  onNodeSelected: PropTypes.func,
  loadingNodeIds: PropTypes.object,
};

TagsTreeView.defaultProps = {
  onNodeToggled: () => {},
  onNodeSelected: () => {},
  loadingNodeIds: {},
};

export default TagsTreeView;
